<script setup>
import { computed, ref, watch } from 'vue';
import { useDateFormat } from '@vueuse/core';

import AppEmptyState from '@/components/general/EmptyState.vue';
import AppSkeletonTable from '@/components/general/SkeletonTable.vue';

import { useCreditsStore } from '@/stores/credits';

const visible = defineModel('visible', false);

const creditStore = useCreditsStore();

watch(
  () => visible.value,
  () => {
    if (visible.value === true) {
      creditStore.fetch();
    }
  },
  { immediate: true }
);
</script>
<template>
  <!-- Empty header to right-align the close button -->
  <Drawer
    v-model:visible="visible"
    header=" "
    position="right"
    class="w-[40%] min-w-[350px] max-w-[600px]"
  >
    <div class="flex flex-col gap-6">
      <Card class="w-full">
        <template #content>
          <div class="flex flex-col gap-4">
            <p class="text-gray-500">Credit balance</p>
            <h2 class="text-3xl font-medium">
              {{ creditStore.creditCountString }}
            </h2>
          </div>
        </template>
      </Card>

      <div v-if="creditStore.loadingHistory">
        <app-skeleton-table :rows="5" :cols="3" />
      </div>

      <DataTable
        v-else-if="creditStore.creditHistory?.length"
        :value="creditStore.creditHistory"
      >
        <Column field="created_at" header="Date">
          <template #body="{ data }">
            <div class="">
              {{ useDateFormat(data.created_at, 'MMM DD, YYYY') }}
            </div>
          </template>
        </Column>
        <Column field="credit_amount" header="Credited" />
        <Column field="credit_remaining" header="Remaining" />
      </DataTable>

      <Card v-else>
        <template #content>
          <app-empty-state
            class="min-h-[200px]"
            icon="icon-[ph--currency-circle-dollar]"
            description="No credit history"
          />
        </template>
      </Card>
    </div>
  </Drawer>
</template>
